module.exports = __webpack_public_path__ + "assets/img/ph_d_2.d711937d.jpg";